export enum TestPanelMode {
	View = 'View',
	Add = 'Add',
	Rearrange = 'Rearrange',
}
